export default __webpack_public_path__ + "static/media/step3.2c6e63cd.svg";